import {loadStripe, Stripe} from "@stripe/stripe-js";

/*
 * Single lazily-initialized Stripe.js instance. loadStripe injects Stripe's
 * script, which serves the Elements iframes — the card PAN/CVC are entered
 * inside those Stripe-hosted iframes and go browser → Stripe directly, never
 * touching our JS or backend (keeps us in PCI SAQ A). The publishable key is
 * safe to ship in the bundle.
 */
let stripePromise: Promise<Stripe | null> | undefined;

export default function getStripePromise(): Promise<Stripe | null> {
    if (!stripePromise) {
        stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);
    }
    return stripePromise;
}
